import Flickity from 'flickity';

const initArtworkCarousel = (): void => {
    document.querySelectorAll('.artwork-carousel__carousel--flickity').forEach((carousel: HTMLElement) => {
        const animate = Number(carousel.getAttribute('data-animate'));

        new Flickity(carousel, {
            autoPlay: animate ? 1500 : false,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            wrapAround: true,
            cellAlign: 'left',
        });
    })
}

export default initArtworkCarousel;
